var leerMas = function () {
    Array.from(document.querySelectorAll('.leer-mas')).forEach(function (boton) {
        boton.addEventListener('click', function (evento) {
            evento.preventDefault();
            var contenedor = document.querySelector('#' + boton.getAttribute('aria-controls'));
            if (contenedor) {
                boton.style.position = 'absolute';
                boton.style.visibility = 'hidden';
                requestAnimationFrame(function () {
                    contenedor.hidden = false;
                    contenedor.addEventListener('transitionend', function () {
                        contenedor.style.maxHeight = 'none';
                        boton.remove();
                    });
                    contenedor.style.maxHeight = contenedor.scrollHeight + 'px';
                });
            }
        });
    });
};
export default leerMas;
